/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconPlaySolid from '@telus-uds/palette-koodo/build/rn/icons/PlaySolid'
const theme = {
  appearances: {
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: { buttonContentChildrenBackground: null }
    }
  ],
  tokens: {
    buttonBackground: '#ffffff',
    buttonBorderColor: null,
    buttonBottomPosition: 24,
    buttonContentBackground: null,
    buttonContentChildrenBackground: null,
    buttonLeftPosition: 24,
    buttonMinHeight: 64,
    buttonPaddingLeft: 16,
    buttonPaddingRight: 16,
    buttonRadius: 32,
    detailsContainerPadding: 8,
    labelFontName: 'StagSans',
    labelFontWeight: '600',
    playIcon: PaletteIconPlaySolid,
    playIconColor: '#ffffff',
    playIconContainerBackground: '#000000'
  }
}
export default theme
